__turbopack_context__.v({
  "closeBtn": "Modal-module__sR2AWG__closeBtn",
  "fadeInItems": "Modal-module__sR2AWG__fadeInItems",
  "modalWrapper": "Modal-module__sR2AWG__modalWrapper",
  "overlay": "Modal-module__sR2AWG__overlay",
  "spacing--lg": "Modal-module__sR2AWG__spacing--lg",
  "spacing--md": "Modal-module__sR2AWG__spacing--md",
  "spacing--sm": "Modal-module__sR2AWG__spacing--sm",
  "spacing--xl": "Modal-module__sR2AWG__spacing--xl",
  "spacing--xs": "Modal-module__sR2AWG__spacing--xs",
  "spacing--xxl": "Modal-module__sR2AWG__spacing--xxl",
  "spacing--xxs": "Modal-module__sR2AWG__spacing--xxs",
  "spacing--xxxl": "Modal-module__sR2AWG__spacing--xxxl",
  "spacing--xxxs": "Modal-module__sR2AWG__spacing--xxxs",
});
